// No Credit/Prize Account ledger endpoint exists on the backend yet — this
// module ships as a static scaffold (matching the Payout/RewardAds pages'
// convention) with mock data matching the Figma design 1:1, ready to be
// swapped for real API calls once the ledger API contract is confirmed.

export const LEDGER_STATS = {
  totalCredit: { value: 'GHS 0.00', trend: 18.6 },
  totalDebits: { value: 'GHS 152,730.00', trend: -9.4 },
  creditAccountTransactions: { value: 0 },
  prizeAccountTransactions: { value: 0 }
}

export const TRANSACTION_SUMMARY = {
  creditAccount: { credits: 'GHS 200,000.60', debits: 'GHS 7,250.00', net: '+GHS 7,250.00' },
  prizeNetMovement: { credits: 'GHS 200,000.60', debits: 'GHS 7,250.00', net: '+GHS 7,250.00' },
  overallNetMovement: { value: 'GHS 200,000.60', hint: 'vs selected period' }
}

export const ACCOUNT_LEGEND = [
  { label: 'Usage', description: 'Campaign or platform usage' },
  { label: 'Top Up', description: 'Funds added to account' },
  { label: 'Payout', description: 'Funds paid out' },
  { label: 'Commission', description: 'Corrections or reversals' },
  { label: 'Adjustment', description: 'Corrections or reversals' }
]

export const CAMPAIGN_OPTIONS = [
  { id: 1, title: 'Recharge & Win - Fuel Season', type: 'Prediction', status: 'Active' },
  { id: 2, title: 'Recharge & Win - Fuel Season', type: 'Engagement', status: 'Upcoming' },
  { id: 3, title: 'Recharge & Win - Fuel Season', type: 'Engagement', status: 'Completed' },
  { id: 4, title: 'Recharge & Win - Fuel Season', type: 'Engagement', status: 'Completed' }
]

export const FILTER_OPTIONS = {
  years: ['This year', 'Last year', 'All time'],
  accounts: ['All Accounts', 'Credit Account', 'Prize Account'],
  types: ['All Types', 'Usage', 'Top Up', 'Payout', 'Commission', 'Adjustment'],
  statuses: ['All Statuses', 'Completed', 'Pending', 'Failed']
}

export const LEDGER_ROWS = [
  {
    id: 'TRX-2026-0012234',
    dateTime: '18 May 2026, 10:24 AM',
    account: 'Credit Account',
    reference: 'TRX-2026-0012234',
    description: 'Sponsored Quiz',
    type: 'Usage',
    amount: -1250,
    balanceAfter: 'GHS 18,450.60',
    balance: 'GHS 17,200.60',
    balanceBefore: 'GHS 17,200.60',
    status: 'Completed'
  },
  {
    id: 'TRX-2026-0012233',
    dateTime: '17 May 2026, 4:02 PM',
    account: 'Prize Account',
    reference: 'TRX-2026-0012233',
    description: 'Weekly prize funding',
    type: 'Top Up',
    amount: 50000,
    balanceAfter: 'GHS 68,450.60',
    balance: 'GHS 18,450.60',
    balanceBefore: 'GHS 18,450.60',
    status: 'Completed'
  },
  {
    id: 'TRX-2026-0012232',
    dateTime: '16 May 2026, 9:41 AM',
    account: 'Prize Account',
    reference: 'TRX-2026-0012232',
    description: 'Weekly winner payout',
    type: 'Payout',
    amount: -7250,
    balanceAfter: 'GHS 18,450.60',
    balance: 'GHS 25,700.60',
    balanceBefore: 'GHS 25,700.60',
    status: 'Completed'
  },
  {
    id: 'TRX-2026-0012231',
    dateTime: '15 May 2026, 1:18 PM',
    account: 'Credit Account',
    reference: 'TRX-2026-0012231',
    description: 'Reward Ads spend',
    type: 'Usage',
    amount: -6250,
    balanceAfter: 'GHS 25,700.60',
    balance: 'GHS 31,950.60',
    balanceBefore: 'GHS 31,950.60',
    status: 'Completed'
  },
  {
    id: 'TRX-2026-0012230',
    dateTime: '14 May 2026, 11:05 AM',
    account: 'Credit Account',
    reference: 'TRX-2026-0012230',
    description: 'Sales commission adjustment',
    type: 'Commission',
    amount: -625,
    balanceAfter: 'GHS 31,950.60',
    balance: 'GHS 32,575.60',
    balanceBefore: 'GHS 32,575.60',
    status: 'Pending'
  },
  {
    id: 'TRX-2026-0012229',
    dateTime: '12 May 2026, 3:47 PM',
    account: 'Credit Account',
    reference: 'TRX-2026-0012229',
    description: 'Manual balance correction',
    type: 'Adjustment',
    amount: 1000,
    balanceAfter: 'GHS 32,575.60',
    balance: 'GHS 31,575.60',
    balanceBefore: 'GHS 31,575.60',
    status: 'Completed'
  },
  {
    id: 'TRX-2026-0012228',
    dateTime: '10 May 2026, 8:30 AM',
    account: 'Credit Account',
    reference: 'TRX-2026-0012228',
    description: 'Mobile money top up',
    type: 'Top Up',
    amount: 20000,
    balanceAfter: 'GHS 31,575.60',
    balance: 'GHS 11,575.60',
    balanceBefore: 'GHS 11,575.60',
    status: 'Completed'
  },
  {
    id: 'TRX-2026-0012227',
    dateTime: '8 May 2026, 6:12 PM',
    account: 'Prize Account',
    reference: 'TRX-2026-0012227',
    description: 'Monthly winner payout',
    type: 'Payout',
    amount: -15000,
    balanceAfter: 'GHS 11,575.60',
    balance: 'GHS 26,575.60',
    balanceBefore: 'GHS 26,575.60',
    status: 'Failed'
  }
]
